export default function DOM_AddNodes() {
  return (
    <div>
      <h1>DOM_AddNodes</h1>
      <p>This is the DOM_AddNodes component.</p>
    </div>
  );
}